import interact from 'interactjs';

export const draggableConfig = {
  modifiers: [
    interact.modifiers.restrictRect({
      restriction: 'parent',
      endOnly: true,
    }),
  ],
};

export const resizableConfig = {
  edges: { top: true, left: true, bottom: true, right: true },
  modifiers: [
    interact.modifiers.restrictEdges({
      outer: 'parent',
    }),
    interact.modifiers.restrictSize({
      min: { width: 50, height: 50 },
    }),
    interact.modifiers.aspectRatio({
      ratio: 'preserve',
      modifiers: [interact.modifiers.restrictSize({ max: 'parent' })],
    }),
  ],
};
